import React from "react";
import { FormattedMessage } from "react-intl";
import { SIZE, TYPE } from "components/Form";
import { MessagesError } from "components/Messages";
import { BlueprintPicker, TaskProcessing } from "components/Missions/Roles/TalentSimple/RoleBuilder";
import {
  AI_ROLE_BUILDER_TASK_DISPLAY_STATE as TASK_DISPLAY_STATE,
  MISSION_ROLE_FORM_FIELDS,
  ROLE_BUILDER_CONFIG,
  TALENT_SIMPLE_ARCHETYPES_OPTIONS,
  getLeftColFields,
  getRightColFields,
  getRoleBuilderTaskDisplayState,
} from "constants/index";

const getJobDescriptionUploadFields = ({ disabled } = {}) => [
  {
    label: <FormattedMessage id="AIRoleBuilder.Form.JobDescriptionFile.Label" />,
    description: <FormattedMessage id="AIRoleBuilder.Form.JobDescriptionFile.Description" />,
    type: TYPE.fileDropzone,
    size: SIZE.xlarge,
    disabled,
    properties: {
      name: "jobDescriptionFile",
      accept: "application/pdf",
      maxFiles: 1,
      dropzoneTextId: "AIRoleBuilder.Form.JobDescriptionFile.DropzoneText",
    },
  },
  {
    label: <FormattedMessage id="AIRoleBuilder.Form.JobDescription.Label" />,
    type: TYPE.textarea,
    size: SIZE.xlarge,
    disabled,
    properties: {
      id: "jobDescription",
      name: "jobDescription",
      rows: ROLE_BUILDER_CONFIG.JOB_DESCRIPTION_ROWS,
    },
  },
];

const getJobDescriptionReviewFields = () => [MISSION_ROLE_FORM_FIELDS.name, MISSION_ROLE_FORM_FIELDS.description];

const getInformationFields = ({ domainId }) => {
  const context = { isRoleBuilder: true, domainId, archetypeOptions: TALENT_SIMPLE_ARCHETYPES_OPTIONS };

  return [...getLeftColFields(context), ...getRightColFields(context)];
};

const getBlueprintFields = () => [
  {
    label: <FormattedMessage id="Missions.Roles.TalentSimple.RoleBuilder.Blueprint.Label" />,
    description: <FormattedMessage id="Missions.Roles.TalentSimple.RoleBuilder.Blueprint.Hint" />,
    type: BlueprintPicker,
    size: SIZE.xlarge,
  },
];

const getAwaitingTaskFields = (task) => {
  if (getRoleBuilderTaskDisplayState(task) === TASK_DISPLAY_STATE.ERROR) {
    return [{ type: MessagesError, size: SIZE.xlarge, properties: { messageId: "AIRoleBuilder.Error" } }];
  }

  return [{ type: TaskProcessing, size: SIZE.xlarge, properties: { task } }];
};

export {
  getAwaitingTaskFields,
  getBlueprintFields,
  getInformationFields,
  getJobDescriptionReviewFields,
  getJobDescriptionUploadFields,
};
